import { sortBy, toNumber } from 'lodash-es';
import type { CiteKnowledge, SourceKnowledge } from 'services/api/supplementKnowledge';
import { isSameKnowledge, resolveKnowledgeType } from './knowledgeType';

export const transformKnowledge = (
  citeKnowledge: CiteKnowledge[],
  sourceKnowledge: SourceKnowledge[],
) => {
  return sortBy(
    citeKnowledge.reduce(
      (res, knowledge) => {
        let target = sourceKnowledge.find((source) => isSameKnowledge(source, knowledge));
        if (
          resolveKnowledgeType(knowledge) === 'product_detail_knowledge' &&
          knowledge.source === '商品详情页'
        ) {
          const sourceTarget = sourceKnowledge.find(
            (source) =>
              resolveKnowledgeType(source) === 'product_detail_knowledge' &&
              source.sourceId != null &&
              `${source.sourceId}` === `${knowledge.knowledgeId}`,
          );
          if (sourceTarget) {
            target = sourceTarget;
          }
        }
        if (!target || (String(knowledge.knowledgeId).startsWith('test') && !target.kvId)) {
          return res;
        }
        res.push({
          citeKnowledge: knowledge,
          sourceKnowledge: target,
        });
        return res;
      },
      [] as {
        citeKnowledge: CiteKnowledge;
        sourceKnowledge: SourceKnowledge;
      }[],
    ),
    ({ citeKnowledge }) => -toNumber(citeKnowledge.score),
  );
};
